import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Card, Affix, Form } from "antd";
import Header from "../../Common/Header";
import HourlyTargetForm from "./HourlyTargetForm";
import { getData } from "../../../apiServices/common";
import { HOURLY_TARGET_SETUP_GARMENTS_TRACKING_GET } from "../../../apiServices/API_ENDPOINTS";
import { message } from "antd";

const CreateOrEditHourlyTarget = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = !!id;
  const [loading, setLoading] = useState(false);
  const [editData, setEditData] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    if (isEdit && id) {
      fetchEditData();
    }
  }, [id, isEdit]);

  const fetchEditData = async () => {
    setLoading(true);
    try {
      const response = await getData(
        `${HOURLY_TARGET_SETUP_GARMENTS_TRACKING_GET}/${id}`,
      );

      if (response && response?.data?.code === 200) {
        setEditData(response.data.data);
      } else {
        message.error("Error fetching hourly target data");
        navigate("/digitalization/garments-tracking-hourly-target");
      }
    } catch (error) {
      message.error("Error fetching hourly target data");
      navigate("/digitalization/garments-tracking-hourly-target");
    } finally {
      setLoading(false);
    }
  };

  const handleDiscard = () => {
    navigate("/digitalization/garments-tracking-hourly-target");
  };

  const submitForm = () => {
    form.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed">
          <Header
            title={`${isEdit ? "Edit" : "Create"} Hourly Target`}
            actions={[
              <Affix offsetTop={20} key="discard">
                <Button size="small" danger onClick={handleDiscard}>
                  Discard
                </Button>
              </Affix>,
              <Affix offsetTop={20} key="submit">
                <Button
                  size="small"
                  type="primary"
                  onClick={submitForm}
                  loading={loading}
                >
                  {isEdit ? "Update" : "Save"}
                </Button>
              </Affix>,
            ]}
          />
        </Card>
      </Affix>
      <HourlyTargetForm
        form={form}
        isEdit={isEdit}
        editData={editData}
        loading={loading}
        onSuccess={() => {
          navigate("/digitalization/garments-tracking-hourly-target");
        }}
      />
    </>
  );
};

export default CreateOrEditHourlyTarget;
